import { Upload, message } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { InputWrapper, SplitInputWrapperProps } from "../../functions";
import { validations } from "../../../../config/validations/validations";
import {  useState } from "react";
import CommonModal from "../../../Modals/CommonModal";
import { RcFile } from "antd/es/upload";
import React from "react";

const CareersImageUploadInputBox: React.FC<any> = (props) => {
  const { formProps, inputProps } = SplitInputWrapperProps(props);
  const [previewImage, setPreviewImage] = useState("");

  const [previewOpen, setPreviewOpen] = useState(false);

  const uploadButton = (
    <div>
      <PlusOutlined />
    </div>
  );

  const onPreview = async (file?: any) => {
    const getBase64 = (file: RcFile) =>
      new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = (error) => reject(error);
      });
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj as RcFile);
    }
    setPreviewImage(file.url || (file.preview as string));
    setPreviewOpen(true);
  };

  const checkFileType = (file: any) => {
    const acceptedFormats = [
      "image/svg+xml",
      "image/jpeg",
      "image/jpg",
      "image/png",
    ];
    if (!acceptedFormats.includes(file.type)) {
      message.error(`Upload valid image. Only PNG, JPEG, SVG are allowed.`);
      return true;
    } else {
      return false;
    }
  };

  return (
    <>
      <InputWrapper
        rules={formProps.required ? [validations.required.text()] : []}
        {...formProps}
      >
        <Upload
          name={formProps.name}
          accept=".png,.jpeg,.jpg,.svg"
          maxCount={1}
          onPreview={onPreview}
          showUploadList={true}
          multiple={false}
          listType="picture-card"
          beforeUpload={checkFileType}
          {...inputProps}
        >
          {inputProps?.fileList < 1 && uploadButton}
        </Upload>
      </InputWrapper>
      <CommonModal
        style={{ maxWidth: "1024px", height: "auto" }}
        open={previewOpen}
        onCancel={() => setPreviewOpen(false)}
      >
        <img alt="example" src={previewImage} />
      </CommonModal>
    </>
  );
};

export default CareersImageUploadInputBox;
